import React from 'react';
import Link from 'gatsby-link';
import colors from 'pubweb-react-components/dist/styles/colors';

import CircleArrow from '../../images/animations/CircleArrow/CircleArrow';

import { SubpageFooterContainer } from './SubpageFooterStyles';
import LandingFooter from '../LandingFooter/LandingFooter';

import {getLinkWithQueryString} from '../../utils/urlTools';

const SubpageFooter = ({
    linkNext,
    linkPrev,
    textNext,
    textPrev
}) => {
     return (
        <SubpageFooterContainer>

            <div className="footer-nav">
                <div className="footer-left">
                    <Link to={getLinkWithQueryString(linkPrev)}>
                        <span className="standard-state">
                            <CircleArrow circleColor={colors.secondaryRubberDucky} arrowColor={colors.grayscaleCoolGray11}  backgroundColor={'rgba(255, 197, 10, 1)'} circleDiameter="33" />
                        </span>
                        <span className="hover-state">
                            <CircleArrow circleColor={colors.secondaryRubberDucky} arrowColor={colors.grayscaleCoolGray11}  backgroundColor={'rgba(255, 197, 10, 0)'} circleDiameter="33" />
                        </span>
                        <span className="nav-text">{textPrev}</span>
                    </Link>
                </div>
                <div className="footer-right">
                    <Link to={getLinkWithQueryString(linkNext)}>
                        <span className="nav-text">{textNext}</span>
                        <span className="standard-state">
                            <CircleArrow circleColor={colors.secondaryRubberDucky} arrowColor={colors.grayscaleCoolGray11}  backgroundColor={'rgba(255, 197, 10, 1)'} circleDiameter="33" />
                        </span>
                        <span className="hover-state">
                            <CircleArrow circleColor={colors.secondaryRubberDucky} arrowColor={colors.grayscaleCoolGray11}  backgroundColor={'rgba(255, 197, 10, 0)'} circleDiameter="33" />
                        </span>
                    </Link>
                </div>
            </div>

            <LandingFooter />
        </SubpageFooterContainer>
    )
};

export default SubpageFooter;



// WEBPACK FOOTER //
// ./src/components/SubpageFooter/SubpageFooter.js